// extracted by mini-css-extract-plugin
export default {"main":"Results_main__Qr+9j","ltr":"Results_ltr__3hAu2","rtl":"Results_rtl__hH+uE","first":"Results_first__RViMo","uploadPdf":"Results_uploadPdf__JxlAc"};